import React from "react";
import { Layout } from "../../layout/Layout.js";
import { VatReportProvider } from "./VatReportProvider.js";
import { VatReportTitle } from "./VatReportTitle.js";
import { VatReportMonth } from "./VatReportMonth.js";
import { VatReportTable } from "./VatReportTable.js";
import { VatReportAccount } from "./VatReportAccount.js";
import { VatReportWarnings } from "./VatReportWarnings.js";

/**
 * Displays monthly VAT report.
 */
export const VatReportPage = () => {
  return (
    <Layout title="Käibemaks" containerWidth="fixed-wide-min">
      <VatReportProvider>
        <VatReportTitle />
        <VatReportMonth />
        <VatReportTable />
        <VatReportWarnings />
        <VatReportAccount />
      </VatReportProvider>
    </Layout>
  );
};
